// extracted by mini-css-extract-plugin
module.exports = {"row":"style_row__2n0G6","label":"style_label__i9aDj"};